// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"cf001cef2eab544526e7","873":"e067128d4dab51745e50"}[chunkId] + ".js";
};